import React from 'react';
import axios from 'axios';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import validator from 'validator';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//styles
import './login.styl';
import './Recover.styl';
import 'bootstrap/dist/css/bootstrap.css';
//text
//config
const baseUrl = require('Config').baseUrl;
class Recover extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      email: '',
      popupText: 'Processing. Just a moment...'
    }
  }

  inputChange = (e) => {
    this.setState({[e.target.name]: e.target.value});
  }

  validate = () => {
  	this.setState({email: validator.escape(this.state.email)});
  	let isEmail = validator.isEmail(this.state.email);
  	return isEmail;
  }

  submitForm = (e) => {
    e.preventDefault();
    this.setState({popupText: 'Just a moment...'});

    const url = `${baseUrl}/users/recover`;

    if(this.validate()){
	    axios.post(url, {
	    	email: this.state.email,
	    })
	    .then(response => {
	      this.setState({popupText: 'Recovery email has been sent!'});
	    })
	    .catch(err => {
	      this.setState({popupText: err.response.data.status});
	    });
    }
    else {
    	this.setState({popupText: 'Please, provide a valid email'});
    }
  }

  popup = () => {
    return (
      <Tooltip className="in" id="tooltip-top">
        <span>{this.state.popupText}</span>
      </Tooltip>
    );
  }

  render(){
    return (
      <SimpleContainer color='white' containerClass='padded-container form-container'>
	      <div className='recover-form-wrapper login-form-wrapper'>
		      <form className='recover-form form-body' onSubmit={this.submitForm}>
            <div className="form__input-field">
              <label htmlFor="email" className='form-text'>email<sup>*</sup></label>
              <input id="email" type='email' name='email' className='input email' placeholder='example@company.com' value={this.state.email} onChange={this.inputChange}/>
            </div>
            <p>We will send you an email to the provided address with the reset instructions <span className='highlight'>address must be registered with aircheckr (if you did not receive one, check spam folder)</span></p>
            <div className="right-align">
  		        <OverlayTrigger className='form-overlay' trigger={'focus'} placement="bottom" overlay={this.popup()}>
  		          <button type="submit" className="button">Submit</button>
  		        </OverlayTrigger>
            </div>
		      </form>
	      </div>
	  </SimpleContainer>
    );
  }
};

export default Recover;



// WEBPACK FOOTER //
// ./src/routes/Recover.js